import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="main-footer">
      <span>&copy; 2026. SAWD. Tous droits réservés.</span>
      <span>Créé par: <Link to="#" >DMS</Link></span>
    </div>
  )
}